// Device helpers — used to send site supervisors straight to Field View on phones.
export const isMobileDevice = () =>
  typeof window !== "undefined" && window.matchMedia("(max-width: 767px)").matches;

/** Where a user should land after signing in: mobile staff go to Field View; homeowners always go to their portal. */
export const landingPathFor = (user) => {
  if (user?.role === "client") return "/portal";
  if (user?.role === "supplier") return "/supplier";
  if (user?.role === "consultant") return "/consultant";
  if (user?.role !== "contractor" && isMobileDevice()) return "/field";
  return "/";
};
